import { render } from "./PartnersClientView.vue?vue&type=template&id=aa3aa0c4&scoped=true"
import script from "./PartnersClientView.vue?vue&type=script&lang=js"
export * from "./PartnersClientView.vue?vue&type=script&lang=js"

import "./PartnersClientView.vue?vue&type=style&index=0&id=aa3aa0c4&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa3aa0c4"]])

export default __exports__